import React from 'react';
import { connect } from 'react-redux';
import { DBCheckBox, DBTextArea, ToolTipBulb } from '_components';
import { PatientCareCenterNoteSection } from '../Section';
import styles from './Common.module.css';
import { fixCommas } from '_helpers';


class PatientCareCenterNoteAssessmentOutcomes extends React.Component {

    getSentence() {
        let sentence = 'The patient has a ';
        if (this.props.selectedOutcomes.length > 0) {
            let temp = Object.keys(this.props.selectedOutcomes)
                .map(key =>
                    this.props.selectedOutcomes[key].OMSCORE ?
                        this.props.selectedOutcomes[key].OMNAME + ' (' + this.props.selectedOutcomes[key].OMSCORE + ')' :
                        this.props.selectedOutcomes[key].OMNAME)
                .join(', ');

            temp = fixCommas(temp);
            sentence += ' ' + temp;
        } else {
            sentence += '[outcome measures]'
        }
        sentence += ' which signifies '
        return sentence;
    }

    render() {
        if (this.props.outReason) {
            return (<span />);
        }
        return (
            <PatientCareCenterNoteSection id='assessment_outcomes' name='Outcome Measures' level={1} className={this.props.noteType === 4 ? "" : styles.required}>
                {this.props.outcomes.length === 0 &&
                    <span className={this.props.noteType === 4 ? "" : styles.warning}>
                        Please include outcome measures in your <span className={styles.link} onClick={() => this.props.outcomesRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })}>Objective</span>.
                    </span>
                }
                {this.props.outcomes.length > 0 &&
                    <div className={styles.outcomes_wrapper}>

                        {Object.keys(this.props.outcomes)
                            .map(key => {
                                const result = this.props.outcomes[key];
                                return (
                                    <span key={result.OMNO} className={styles.row}>
                                        <DBCheckBox
                                            noteId={this.props.noteId}
                                            entity='PTOUTMEASURES'
                                            entityKeyColumn='OMNO'
                                            entityKeyValue={result.OMNO}
                                            field='OMONASSESSMENT'
                                            className={styles.outmeasure_checkbox}
                                            label={result.OMSCORE ? result.OMNAME + ' (' + result.OMSCORE + ')' : result.OMNAME}
                                        />
                                    </span>
                                )
                            })
                        }
                        <span className={styles.row}>
                            <div className={styles.outmeasure_sentence}>
                                {this.getSentence()}
                            </div>
                        </span>

                        <span className={styles.row}>
                            <DBTextArea
                                noteId={this.props.noteId}
                                entity='PTASSESSMENT'
                                entityKeyColumn='ASNO'
                                entityKeyValue={this.props.asno}
                                field='ASOUTCOMEDESC'
                                placeholder='Discuss significance of the outcome measure score for your patient, provide goal score, and how will you address with your POC.'
                                className={styles.outmeasure_textarea}
                            />
                            <span className={styles.lightbulb}>

                                <ToolTipBulb uid={'ASS_OUTMEASURE_' + this.props.noteId} position='right' width={400} size='extra-small'>
                                    <b>For example:</b><br />
                                    This patient has a FOTO Intake FS Score of 50, which signifies an overall
                                    mod severity functional status. Goal will be score of 75 to improve the pt’s
                                    func status to min severity. Functional goals for this patient include walking.
                                    The pt presents with a lack of knee ext and frequent buckling with ambulation.
                                    Treatment will include ROM to inc knee ext to WNL, strengthening to restore
                                    quad/HS eccentric control and gait training to improve knee ext control
                                    during ambulation.
                                </ToolTipBulb >
                            </span>
                        </span>


                    </div>
                }
            </PatientCareCenterNoteSection>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let asno = parseInt(Object.keys(state.entities.notes.PTASSESSMENT)
        .find(key => (state.entities.notes.PTASSESSMENT[key].ASEVNO === pk && noteType === 1)
            || (state.entities.notes.PTASSESSMENT[key].ASNTNO === pk && noteType !== 1)));
    let outcomes = Object.keys(state.entities.notes.PTOUTMEASURES)
        .filter(key => (state.entities.notes.PTOUTMEASURES[key].OMEVNO === pk && noteType === 1 && state.entities.notes.PTOUTMEASURES[key].OMNAME)
            || (state.entities.notes.PTOUTMEASURES[key].OMNTNO === pk && noteType !== 1 && state.entities.notes.PTOUTMEASURES[key].OMNAME))
        .sort((a, b) => { return state.entities.notes.PTOUTMEASURES[a].OMNO - state.entities.notes.PTOUTMEASURES[b].OMNO; })
        .map(key => state.entities.notes.PTOUTMEASURES[key]);
    let selectedOutcomes = Object.keys(outcomes)
        .filter(key => {
            return (outcomes[key].OMONASSESSMENT === true);
        })
        .map(key => outcomes[key]);
    let prefix = noteType === 1 ? 'EV' : 'NT';
    let table = noteType === 1 ? 'PTEVAL' : 'PTNOTE';
    let outReason = state.entities.notes[table][pk][prefix + 'OBJNOOUTCOMEREASON'];

    return {
        noteId,
        asno,
        outcomes,
        selectedOutcomes,
        outReason,
        noteType
    };
}

const connectedPatientCareCenterNoteAssessmentOutcomes = connect(mapStateToProps)(PatientCareCenterNoteAssessmentOutcomes);
export { connectedPatientCareCenterNoteAssessmentOutcomes as PatientCareCenterNoteAssessmentOutcomes };

